import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'
import { ProductionRoute } from '@/features/production-routes/api/ProductionRouteModel'
import { AggregatedElectricity } from '../finalizedReports'

export const PRODUCTION_ROUTES_QUERY_KEY = 'v2_production-routes'

export type ProductionRoutePeriodCoverage = {
  month: string
  reportingEnabled: boolean
  reportSubmitted: boolean
  reportDraft: boolean
}

type ProductionRouteMethodAggregatedEmissions = {
  activityLevel: number
  cnCodes: string[]
  combinedElectricityConsumptionMWh: number
  combinedElectricityEmissionFactor: number
  combinedSpecificElectricityConsumption: number
  electricityConsumptionMWh: number
  onSiteElectricityCombinedEmissionFactor: number
  onSiteElectricityConsumptionMWh: number
  onSiteSpecificElectricityConsumption: number
  onSiteSpecificElectricityEmissions: number
  precursorElectricityCombinedEmissionFactor: number
  precursorElectricityConsumptionMWh: number
  precursorElectricityConsumptionPerTofProduct: number
  precursorSpecificIndirectEmissions: number
  productionMethodCode: string
  specificElectricityConsumption: number
  specificEmbeddedDirect: number
  specificEmbeddedIndirect: number
}

type ProductionRoutePeriodSummary = {
  coverage: ProductionRoutePeriodCoverage[]
  methodAggregatedEmissions: ProductionRouteMethodAggregatedEmissions[]
  productionRouteId: string
  productionRouteName: string
  finalizedReportId: string | null
  startDate: string
  endDate: string
  finalizedReportStatus: 'PENDING' | 'SUBMITTED' | null
  aggregatedElectricity: AggregatedElectricity
}

export const useGetProductionRoutesForInstallation = (installationId: string) => {
  return useQuery({
    queryKey: [PRODUCTION_ROUTES_QUERY_KEY, installationId],
    queryFn: async () => {
      const res = await apiClient.get<ProductionRoute[]>(
        `/v2/installations/${installationId}/production-routes`
      )
      return res.data
    }
  })
}

export const useGetProductionRoutePeriodSummary = (
  installationId: string,
  productionRouteId: string,
  periodId: string
) => {
  return useQuery({
    queryKey: [PRODUCTION_ROUTES_QUERY_KEY, installationId, productionRouteId, periodId],
    queryFn: async () => {
      const res = await apiClient.get<ProductionRoutePeriodSummary>(
        `/v2/installations/${installationId}/production-routes/${productionRouteId}/period/${periodId}`
      )
      return res.data
    }
  })
}
